import { ISvgProps } from '@src/types';

const Shapes = ({ width = '22px', height = '22px', fillColor = 'var(--font-color)', ...props }: ISvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M9.30991016,11.8302419 L0.859375,11.8302419 C0.384742187,11.8302419 0,12.2149841 0,12.6896169 L0,21.1401517 C0,21.6147845 0.384742187,21.9995267 0.859375,21.9995267 L9.30991016,21.9995267 C9.78454297,21.9995267 10.1692852,21.6147845 10.1692852,21.1401517 L10.1692852,12.6896169 C10.1692852,12.2149841 9.7845,11.8302419 9.30991016,11.8302419 Z M8.45053516,20.2807768 L1.71875,20.2807768 L1.71875,13.5489919 L8.45053516,13.5489919 L8.45053516,20.2807768 Z M16.9153789,11.8302419 C14.1117109,11.8302419 11.8307578,14.111195 11.8307578,16.9149058 C11.8307578,19.7185736 14.1117109,21.9995267 16.9153789,21.9995267 C19.7190898,21.9995267 22,19.7185736 22,16.9149058 C22,14.111195 19.7190469,11.8302419 16.9153789,11.8302419 L16.9153789,11.8302419 Z M16.9153789,20.2807768 C15.0594297,20.2807768 13.5495078,18.7708549 13.5495078,16.9149058 C13.5495078,15.0589566 15.0594297,13.5489919 16.9153789,13.5489919 C18.7713281,13.5489919 20.28125,15.0589566 20.28125,16.9149058 C20.28125,18.7708549 18.7713281,20.2807768 16.9153789,20.2807768 Z M5.9296875,10.1688123 L16.0703125,10.1688123 C16.7375312,10.1688123 17.150375,9.43924594 16.8072266,8.86728893 L11.7369141,0.416754114 C11.4039922,-0.138101332 10.5969961,-0.139734144 10.2630859,0.416754114 L5.19277344,8.86728893 C4.84949609,9.43941781 5.26268359,10.1688123 5.9296875,10.1688123 Z M11,2.52922669 L14.5524844,8.45006238 L7.44751562,8.45006238 L11,2.52922669 Z"
          id="Shape"
          fill={fillColor}
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  );
};

export default Shapes;
